import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Paper,
    Divider,
    Stack,
    IconButton,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

const comments = [
    {
        id: 1,
        user: { name: "Ashok Verma", avatar: "" },
        text: "Initial project files uploaded. Please review.",
        createdAt: "2025-10-31T09:15:00Z",
        attachments: [
            { name: "project_plan.pdf", url: "#" },
            { name: "wireframe.png", url: "#" },
        ],
    },
    {
        id: 2,
        user: { name: "Priya Sharma", avatar: "" },
        text: "Reviewed the files — looks good! Let’s schedule a meeting tomorrow.",
        createdAt: "2025-10-31T11:30:00Z",
        attachments: [],
    },
    {
        id: 3,
        user: { name: "John Doe", avatar: "" },
        text: "Updated the plan document with new budget details.",
        createdAt: "2025-10-31T13:45:00Z",
        attachments: [{ name: "budget_update.xlsx", url: "#" }],
    },
];

const CommentList = () => {
    return (
        <Box
            sx={{
                
                mx: "auto",
                // mt: 4,
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Comments & Attachments
            </Typography> */}

            {comments.map((comment, index) => (
                <Paper
                    key={comment.id}
                    elevation={0}
                    sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        backgroundColor: "#fafafa",
                    }}
                >
                    {/* Header */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ bgcolor: "#3f51b5" }}>
                            {comment.user.name.charAt(0)}
                        </Avatar>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                {comment.user.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {new Date(comment.createdAt).toLocaleString()}
                            </Typography>
                        </Box>
                    </Stack>

                    {/* Comment Text */}
                    <Typography
                        variant="body2"
                        sx={{ mt: 1.5, color: "#333", lineHeight: 1.6 }}
                    >
                        {comment.text}
                    </Typography>

                    {/* Attachments */}
                    {comment.attachments.length > 0 && (
                        <Box sx={{ mt: 1.5 }}>
                            <Typography
                                variant="caption"
                                sx={{ color: "text.secondary", mb: 0.5, display: "block" }}
                            >
                                Attachments:
                            </Typography>
                            <Stack spacing={1}>
                                {comment.attachments.map((file, i) => (
                                    <Paper
                                        key={i}
                                        variant="outlined"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            p: 1,
                                            pl: 1.5,
                                            borderRadius: 1,
                                            borderColor: "#ddd",
                                            bgcolor: "#fff",
                                        }}
                                    >
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <AttachmentIcon fontSize="small" color="action" />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "#1976d2",
                                                    textDecoration: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {file.name}
                                            </Typography>
                                        </Stack>
                                        <IconButton size="small">
                                            <DownloadIcon fontSize="small" />
                                        </IconButton>
                                    </Paper>
                                ))}
                            </Stack>
                        </Box>
                    )}

                    {index < comments.length - 1 && (
                        <Divider sx={{ mt: 2, mb: 0, borderColor: "#e0e0e0" }} />
                    )}
                </Paper>
            ))}
        </Box>
    );
};

export default CommentList;
